export default class DraftEdit extends HTMLDivElement {

    constructor() {
        super();

        this.submitButtons = document.querySelectorAll('.submit-draft');
        this.addToDraftButton = document.getElementById('add-product-to-draft');
        this.addUrl = document.getElementById('add-product-to-draft').dataset.url;
    }

    connectedCallback() {
        this.generateDeletedAction();
        this.saveDraft();
        this.addProductToDraft();
    }

    generateDeletedAction() {
        this.deleteButtons = this.querySelectorAll('.delete-line');

        this.deleteButtons.forEach((deleteButton) => {
            deleteButton.addEventListener('click', (e) => {
                e.preventDefault();

                /* Modal créée ici pour tenir compte de l'élément cliqué */
                const modalHtml = `
                    <div class="modal fade" id="deleteConfirmModal" tabindex="-1" role="dialog" aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="deleteConfirmModalLabel">Confirmation</h5>
                          </div>
                          <div class="modal-body">
                            Êtes-vous sûr de vouloir supprimer cette ligne ?
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                            <button type="button" class="btn btn-danger" id="confirmDeleteBtn">Supprimer</button>
                          </div>
                        </div>
                      </div>
                    </div>`;

                document.body.insertAdjacentHTML('beforeend', modalHtml);
                const modal = new bootstrap.Modal(document.getElementById('deleteConfirmModal'));
                modal.show();

                document.getElementById('confirmDeleteBtn').onclick = () => {
                    const cardBody = deleteButton.closest('.card-body');
                    cardBody.remove();
                    modal.hide();
                    document.getElementById('deleteConfirmModal').remove();
                };

                document.getElementById('deleteConfirmModal').addEventListener('hidden.bs.modal', () => {
                    document.getElementById('deleteConfirmModal').remove();
                });
            });
        });
    }

    addProductToDraft() {
        this.addToDraftButton.addEventListener('click', (e) => {
            e.preventDefault();

            const productId = document.querySelector('select[name="product_id"]').value;

            if (productId) {
                // Si on trouve un input quantity avec le même product_id, on ajoute 1 à la quantité
                const quantityInputs = this.querySelectorAll('.quantity-draft');
                let found = false;
                quantityInputs.forEach(input => {
                    if (input.dataset.productId === productId) {
                        input.value = parseInt(input.value) + 1;
                        found = true;
                    }
                });

                // Sinon, on ajoute une nouvelle ligne avec le product_id et la quantité 1
                if (!found) {
                    // On va chercher le template en ajax pour ajouter une nouvelle ligne
                    fetch(this.addUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        },
                        body: JSON.stringify({ product_id: productId }),
                    })
                        .then((response) => {
                            // On ajoute la réponse HTML dans le container draft-products
                            return response.text();
                        })
                        .then((html) => {
                            this.insertAdjacentHTML('beforeend', html);
                            this.generateDeletedAction();
                        });
                }
            } else {
                console.error('Product ID are required.');
            }
        });
    }

    saveDraft() {
        this.submitButtons.forEach((submitButton) => {
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();

                const quantityInputs = this.querySelectorAll('.quantity-draft');
                const quantities = {};

                quantityInputs.forEach(input => {
                    const productId = input.dataset.productId;
                    const quantity = parseInt(input.value);
                    if (quantity > 0) {
                        quantities[productId] = quantity;
                    }
                });

                // Envoi des données au serveur
                fetch(submitButton.dataset.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    },
                    body: JSON.stringify({ quantities }),
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            window.location.href = data.url;
                        } else {
                            console.error('Error saving draft:', data.message);
                        }
                    })
                    .catch(error => console.error('Error:', error));
            });
        });
    }
}
